import React from 'react';
import "../../Styles/DashboardLayout.css";
import AdminDashboardRoutes from './AdminDashboardRoutes';
import AdminDashNav from './AdminDashNav';
import AdminSidebar from './AdminSidebar';

function AdminDashboardLayout() {
  return (
    <div className="admin-layout">
      <AdminDashNav />
      <AdminSidebar />

      <main className="admin-main-content">
        <AdminDashboardRoutes />
      </main>
    </div>
  );
}

export default AdminDashboardLayout;